@let rev = revision();
@let letsikring = letsikringAfIndtaegt();
<div [formGroup]="form()">
  <section formGroupName="gaeldendeRevision">
    <section formGroupName="letsikringAfIndtaegt">
      @if (rev.aftaleDokument) {
        <div class="detail-section-header">Dokumentoplysninger</div>

        <app-detail-row [editMode]="editMode()" label="Tilbuds nr.">
          {{ letregisterService.getTilbudsnr(rev) }}
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Navn">
          {{ rev.aftaleDokument.emne }}
          <p-button
            label="Vis dokument"
            icon="pi pi-eye"
            outlined
            size="small"
            class="ml-2"
            (click)="dokumentService.hentDokument(rev.aftaleDokument)" />
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Underskriftsmetode">
          {{
            rev.aftaleDokument.signeringStatus?.signeringsMetode || 'På papir'
          }}
        </app-detail-row>
      }

      @if (letsikring.tegningsmaade === 'Arbejdsgiver') {
        <div class="detail-section-header">Arbejdsgiver</div>

        <app-detail-row [editMode]="editMode()" label="Arbejdsgiver CVR-nr.">
          {{ letsikring.arbejdsgiverCvr }}
          <ng-template #editor
            ><input pInputText formControlName="arbejdsgiverCvr"
          /></ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Arbejdsgiver navn">
          {{ letsikring.arbejdsgiverNavn }}
          <ng-template #editor
            ><input
              pInputText
              formControlName="arbejdsgiverNavn"
              style="width: 500px"
          /></ng-template>
        </app-detail-row>
      }
    </section>
  </section>
  <div class="detail-section-header">Opsparing</div>
  <section formGroupName="opsparetVaerdi">
    <app-detail-row [editMode]="editMode()" label="Indbetalt år til dato">
      {{ opsparetVaerdi()?.indbetaltAarTilDato | number: '1.2' }}
      <ng-template #editor>
        <p-input-number
          formControlName="indbetaltAarTilDato"
          locale="da"
          [maxFractionDigits]="2"
          mode="decimal" />
      </ng-template>
    </app-detail-row>

    <app-detail-row [editMode]="editMode()" label="Indbetalt år til dato">
      {{ opsparetVaerdi()?.opsparetVaerdi | number: '1.2' }}
      <ng-template #editor>
        <p-input-number
          formControlName="opsparetVaerdi"
          locale="da"
          [maxFractionDigits]="2"
          mode="decimal" />
      </ng-template>
    </app-detail-row>

    <app-detail-row [editMode]="editMode()" label="Opsparet værdi kundekapital">
      {{ opsparetVaerdi()?.opsparetVaerdiKundeKapital | number: '1.2' }}
      <ng-template #editor>
        <p-input-number
          formControlName="opsparetVaerdiKundeKapital"
          locale="da"
          [maxFractionDigits]="2"
          mode="decimal" />
      </ng-template>
    </app-detail-row>
  </section>

  <section formGroupName="gaeldendeRevision">
    <section formGroupName="letsikringAfIndtaegt">
      <div class="detail-section-header">Indbetaling</div>
      <app-detail-row
        [editMode]="editMode()"
        label="Kunden er omfattet af 30% reglerne"
        >{{ letsikring.selvstaendigErhvervsdrivendeOrdning | boolean }}
        <ng-template #editor>
          <p-checkbox
            formControlName="selvstaendigErhvervsdrivendeOrdning"
            [binary]="true" />
        </ng-template>
      </app-detail-row>

      <section formGroupName="indbetaling">
        <app-detail-row [editMode]="editMode()" label="Opsparing er sat i bero"
          >{{ letsikring.indbetaling?.iBero | boolean }}
          <ng-template #editor>
            <p-checkbox formControlName="iBero" [binary]="true" />
          </ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Engangsindbetaling"
          >{{ letsikring.indbetaling?.indskud | boolean }}
          <ng-template #editor>
            <p-checkbox formControlName="indskud" [binary]="true" />
          </ng-template>
        </app-detail-row>

        @if (
          letsikring.indbetaling?.indskud ||
          form().value.gaeldendeRevision?.letsikringAfIndtaegt?.indbetaling
            ?.indskud
        ) {
          @if (letsikring.tegningsmaade === 'Privat') {
            <app-detail-row [editMode]="editMode()" label="Beløb"
              >{{ letsikring.indbetaling?.indskudPrivatBeloeb | number: '1.2' }}
              <ng-template #editor>
                <p-input-number
                  formControlName="indskudPrivatBeloeb"
                  locale="da"
                  [maxFractionDigits]="2"
                  mode="decimal" />
              </ng-template>
            </app-detail-row>
          }
          @if (letsikring.tegningsmaade === 'Arbejdsgiver') {
            <app-detail-row
              [editMode]="editMode()"
              label="Beløb fra medarbejder"
              >{{
                letsikring.indbetaling?.indskudMedarbejderBeloeb | number: '1.2'
              }}
              <ng-template #editor>
                <p-input-number
                  formControlName="indskudMedarbejderBeloeb"
                  locale="da"
                  [maxFractionDigits]="2"
                  mode="decimal" />
              </ng-template>
            </app-detail-row>

            <app-detail-row
              [editMode]="editMode()"
              label="Beløb fra arbejdsgiver"
              >{{
                letsikring.indbetaling?.indskudArbejdsgiverBeloeb
                  | number: '1.2'
              }}
              <ng-template #editor>
                <p-input-number
                  formControlName="indskudArbejdsgiverBeloeb"
                  locale="da"
                  [maxFractionDigits]="2"
                  mode="decimal" />
              </ng-template>
            </app-detail-row>
          }

          <app-detail-row [editMode]="editMode()" label="Dato"
            >{{ letsikring.indbetaling?.indskudDato | date: 'dd-MM-yyyy' }}
            <ng-template #editor>
              <app-let-date-picker formControlName="indskudDato" />
            </ng-template>
          </app-detail-row>

          <app-detail-row label="Indbetalingskonto" />
          <app-konto
            [editMode]="editMode()"
            [formPath]="[
              'gaeldendeRevision',
              'letsikringAfIndtaegt',
              'indbetaling',
              'indskudskonto',
            ]"
            [konto]="letsikring.indbetaling?.indskudskonto" />
        }

        <app-detail-row [editMode]="editMode()" label="Løbende indbetaling"
          >{{ letsikring.indbetaling?.loebendeIndbetaling | boolean }}
          <ng-template #editor>
            <p-checkbox formControlName="loebendeIndbetaling" [binary]="true" />
          </ng-template>
        </app-detail-row>

        @if (
          letsikring.indbetaling?.loebendeIndbetaling ||
          form().value.gaeldendeRevision?.letsikringAfIndtaegt?.indbetaling
            ?.loebendeIndbetaling
        ) {
          <app-detail-row [editMode]="editMode()" label="Næste indbetaling"
            >{{
              letsikring.indbetaling?.loebendeNaesteIndbetalingDato
                | date: 'dd-MM-yyyy'
            }}
            <ng-template #editor>
              <app-let-date-picker
                formControlName="loebendeNaesteIndbetalingDato" />
            </ng-template>
          </app-detail-row>

          <app-detail-row [editMode]="editMode()" label="Betalingsfrekvens"
            >{{ letsikring.indbetaling?.loebendeIndbetalingFrekvens }}
            <ng-template #editor>
              <p-select
                [options]="loebendeIndbetalingFrekvensOptions"
                class="w-[178px]"
                formControlName="loebendeIndbetalingFrekvens"
                optionLabel="text"
                optionValue="value"
                appendTo="body" />
            </ng-template>
          </app-detail-row>

          <app-detail-row [editMode]="editMode()" label="Sidste indbetaling"
            >{{
              letsikring.indbetaling?.loebendeSidsteIndbetalingDato
                | date: 'dd-MM-yyyy'
            }}
            <ng-template #editor>
              <app-let-date-picker
                formControlName="loebendeSidsteIndbetalingDato" />
            </ng-template>
          </app-detail-row>

          <app-detail-row
            [editMode]="editMode()"
            label="Indbetales længst muligt"
            >{{
              letsikring.indbetaling?.loebendeIndbetalingLaengstMulig | boolean
            }}
            <ng-template #editor>
              <p-checkbox
                formControlName="loebendeIndbetalingLaengstMulig"
                [binary]="true" />
            </ng-template>
          </app-detail-row>

          @if (
            letsikring.tegningsmaade === 'Arbejdsgiver' ||
            form().value.gaeldendeRevision?.letsikringAfIndtaegt
              ?.tegningsmaade === 'Arbejdsgiver'
          ) {
            <app-detail-row
              [editMode]="editMode()"
              label="Løbende indbetaling i procent"
              >{{
                letsikring.indbetaling?.loebendeIndbetalingIprocent | boolean
              }}
              <ng-template #editor>
                <p-checkbox
                  formControlName="loebendeIndbetalingIprocent"
                  [binary]="true" />
              </ng-template>
            </app-detail-row>

            @if (
              letsikring.indbetaling?.loebendeIndbetalingIprocent ||
              form().value.gaeldendeRevision?.letsikringAfIndtaegt?.indbetaling
                ?.loebendeIndbetalingIprocent
            ) {
              <app-detail-row
                [editMode]="editMode()"
                label="Pct. fra arbejdsgiver"
                >{{
                  letsikring.indbetaling?.loebendeArbejdsgiverIndbetalingPct
                    | number: '1.2'
                }}
                <ng-template #editor>
                  <p-input-number
                    formControlName="loebendeArbejdsgiverIndbetalingPct"
                    locale="da"
                    [maxFractionDigits]="2"
                    mode="decimal" />
                </ng-template>
              </app-detail-row>

              <app-detail-row
                [editMode]="editMode()"
                label="Pct. fra medarbejder"
                >{{
                  letsikring.indbetaling?.loebendeMedarbejderIndbetalingPct
                    | number: '1.2'
                }}
                <ng-template #editor>
                  <p-input-number
                    formControlName="loebendeMedarbejderIndbetalingPct"
                    locale="da"
                    [maxFractionDigits]="2"
                    mode="decimal" />
                </ng-template>
              </app-detail-row>

              <app-detail-row
                [editMode]="editMode()"
                label="Pensionsgivende løn"
                >{{
                  letsikring.indbetaling?.pensionsgivendeLoen | number: '1.2'
                }}
                <ng-template #editor>
                  <p-input-number
                    formControlName="pensionsgivendeLoen"
                    locale="da"
                    [maxFractionDigits]="2"
                    mode="decimal" />
                </ng-template>
              </app-detail-row>
            } @else {
              <app-detail-row
                [editMode]="editMode()"
                label="Beløb fra arbejdsgiver"
                >{{
                  letsikring.indbetaling?.loebendeArbejdsgiverIndbetalingBeloeb
                    | number: '1.2'
                }}
                <ng-template #editor>
                  <p-input-number
                    formControlName="loebendeArbejdsgiverIndbetalingBeloeb"
                    locale="da"
                    [maxFractionDigits]="2"
                    mode="decimal" />
                </ng-template>
              </app-detail-row>

              <app-detail-row
                [editMode]="editMode()"
                label="Beløb fra medarbejder"
                >{{
                  letsikring.indbetaling?.loebendeMedarbejderIndbetalingBeloeb
                    | number: '1.2'
                }}
                <ng-template #editor>
                  <p-input-number
                    formControlName="loebendeMedarbejderIndbetalingBeloeb"
                    locale="da"
                    [maxFractionDigits]="2"
                    mode="decimal" />
                </ng-template>
              </app-detail-row>
            }
          }

          @if (
            letsikring.tegningsmaade === 'Privat' ||
            form().value.gaeldendeRevision?.letsikringAfIndtaegt
              ?.tegningsmaade === 'Privat'
          ) {
            <app-detail-row [editMode]="editMode()" label="Beløb"
              >{{
                letsikring.indbetaling?.loebendePrivatIndbetalingBeloeb
                  | number: '1.2'
              }}
              <ng-template #editor>
                <p-input-number
                  formControlName="loebendePrivatIndbetalingBeloeb"
                  locale="da"
                  [maxFractionDigits]="2"
                  mode="decimal" />
              </ng-template>
            </app-detail-row>

            <app-detail-row [editMode]="editMode()" label="Regulering"
              >{{ letsikring.indbetaling?.loebendePrivatIndbetalingRegulering }}
            </app-detail-row>
          }

          <app-detail-row label="Indbetalingskonto" />
          <app-konto
            [editMode]="editMode()"
            [formPath]="[
              'gaeldendeRevision',
              'letsikringAfIndtaegt',
              'indbetaling',
              'loebendeIndbetalingKonto',
            ]"
            [konto]="letsikring.indbetaling?.loebendeIndbetalingKonto" />
        }
      </section>

      <div class="detail-section-header">Overløbsaftale</div>
      <app-detail-row [editMode]="editMode()" label="Overløbsaftale"
        >{{ letsikring.overloebFraRatepension | boolean }}
        <ng-template #editor>
          <p-checkbox
            formControlName="overloebFraRatepension"
            [binary]="true" />
        </ng-template>
      </app-detail-row>

      @if (
        letsikring.overloebFraRatepension ||
        form().value.gaeldendeRevision?.letsikringAfIndtaegt
          ?.overloebFraRatepension
      ) {
        <app-detail-row
          [editMode]="editMode()"
          label="Årlig opsparing på Letsikringen"
          >{{ letsikring.aarligIndbetaling | number: '1.2' }}
          <ng-template #editor>
            <p-input-number
              formControlName="aarligIndbetaling"
              locale="da"
              [maxFractionDigits]="2"
              mode="decimal" />
          </ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Tærskelværdi"
          >{{ letsikring.rateOverloebsgraense | number: '1.2' }}
          <ng-template #editor>
            <p-input-number
              formControlName="rateOverloebsgraense"
              locale="da"
              [maxFractionDigits]="2"
              mode="decimal" />
          </ng-template>
        </app-detail-row>

        <app-detail-row label="Overløbsrate" />
        <app-konto
          [editMode]="editMode()"
          [formPath]="[
            'gaeldendeRevision',
            'letsikringAfIndtaegt',
            'overloebsRateKonto',
          ]"
          [konto]="letsikring.overloebsRateKonto" />
      }

      <div class="detail-section-header">Udbetaling</div>
      <app-detail-row
        [editMode]="editMode()"
        label="Aftalen er under udbetaling"
        >{{ letsikring.underUdbetaling | boolean }}
        <ng-template #editor>
          <p-checkbox formControlName="underUdbetaling" [binary]="true" />
        </ng-template>
      </app-detail-row>

      <app-detail-row [editMode]="editMode()" label="Udbetaling starter"
        >{{ letsikring.udbetalingStart | date: 'dd-MM-yyyy' }}
        <ng-template #editor>
          <app-let-date-picker formControlName="udbetalingStart" />
        </ng-template>
      </app-detail-row>

      <app-detail-row [editMode]="editMode()" label="Aftalen er tilbagekøbt"
        >{{ !!letsikring.tilbagekoeb | boolean }}
        <ng-template #editor>
          <p-checkbox formControlName="tilbagekoebValgt" [binary]="true" />
        </ng-template>
      </app-detail-row>

      @if (
        form().value.gaeldendeRevision?.letsikringAfIndtaegt?.tilbagekoebValgt
      ) {
        <section formGroupName="tilbagekoeb">
          <app-detail-row [editMode]="editMode()" label="Nemkonto"
            >{{ letsikring.tilbagekoeb?.nemkonto | boolean }}
            <ng-template #editor>
              <p-checkbox formControlName="nemkonto" [binary]="true" />
            </ng-template>
          </app-detail-row>

          <app-detail-row [editMode]="editMode()" label="Dato"
            >{{ letsikring.tilbagekoeb?.tilbagekoebDato | date: 'dd-MM-yyyy' }}
            <ng-template #editor>
              <app-let-date-picker formControlName="tilbagekoebDato" />
            </ng-template>
          </app-detail-row>

          <app-detail-row label="Konto" />
          <app-konto
            [editMode]="editMode()"
            [formPath]="[
              'gaeldendeRevision',
              'letsikringAfIndtaegt',
              'tilbagekoeb',
              'tilbagekoebKonto',
            ]"
            [konto]="letsikring.tilbagekoeb?.tilbagekoebKonto" />
        </section>
      }

      <section formGroupName="udbetaling">
        <app-detail-row [editMode]="editMode()" label="Nemkonto"
          >{{ letsikring.udbetaling?.nemkonto | boolean }}
          <ng-template #editor>
            <p-checkbox formControlName="nemkonto" [binary]="true" />
          </ng-template>
        </app-detail-row>

        <app-detail-row label="Udbetalingskonto" />
        <app-konto
          [editMode]="editMode()"
          [formPath]="[
            'gaeldendeRevision',
            'letsikringAfIndtaegt',
            'udbetaling',
            'udbetalingskonto',
          ]"
          [konto]="letsikring.udbetaling?.udbetalingskonto" />

        <app-detail-row
          [editMode]="editMode()"
          label="Oplysninger om skattekort"
          >{{ letsikring.udbetaling?.skatteKortType }}
          <ng-template #editor>
            <p-select
              [options]="skatteKortTypeOptions"
              class="w-[178px]"
              formControlName="skatteKortType"
              optionLabel="text"
              optionValue="value"
              appendTo="body" />
          </ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Engangsudbetaling"
          >{{ letsikring.udbetaling?.konverterTilEngangsudbetaling | boolean }}
          <ng-template #editor>
            <p-checkbox
              formControlName="konverterTilEngangsudbetaling"
              [binary]="true" />
          </ng-template>
        </app-detail-row>
      </section>

      <div class="detail-section-header">Simuleret udbetaling</div>
      <app-detail-row [editMode]="editMode()" label="Simuleret udbetaling valgt"
        >{{ !!letsikring.simUdbetalingStart | boolean }}
      </app-detail-row>

      <app-detail-row
        [editMode]="editMode()"
        label="Simuleret udbetaling starter"
        >{{ letsikring.simUdbetalingStart | date: 'dd-MM-yyyy' }}
        <ng-template #editor>
          <app-let-date-picker formControlName="simUdbetalingStart" />
        </ng-template>
      </app-detail-row>

      <app-detail-row [editMode]="editMode()" label="Simuleret garantiperiode">
        {{ letsikring.simGarantiPeriode }}
        <ng-template #editor
          ><input pInputText formControlName="simGarantiPeriode"
        /></ng-template>
      </app-detail-row>

      <div class="detail-section-header">Præmiefritagelse</div>
      <app-detail-row [editMode]="editMode()" label="Præmiefritagelse"
        >{{ letsikring.praemiefritagelse | boolean }}
        <ng-template #editor>
          <p-checkbox formControlName="praemiefritagelse" [binary]="true" />
        </ng-template>
      </app-detail-row>

      <div class="detail-section-header">Depotsikring</div>
      <app-detail-row [editMode]="editMode()" label="Depotsikring"
        >{{ letsikring.depotsikring | boolean }}
        <ng-template #editor>
          <p-checkbox formControlName="depotsikring" [binary]="true" />
        </ng-template>
      </app-detail-row>

      @if (
        letsikring.depotsikring ||
        form().value.gaeldendeRevision?.letsikringAfIndtaegt?.depotsikring
      ) {
        <app-detail-row [editMode]="editMode()" label="Nærmeste pårørende"
          >{{ letsikring.naermestePaaroerendeBegunstigelse | boolean }}
          <ng-template #editor>
            <p-checkbox
              formControlName="naermestePaaroerendeBegunstigelse"
              [binary]="true" />
          </ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Indbetalingstype"
          >{{ letsikring.depotsikringIndbetalingstype }}
          <ng-template #editor>
            <p-select
              [options]="depotsikringIndbetalingstypeOptions"
              class="w-[178px]"
              formControlName="depotsikringIndbetalingstype"
              optionLabel="text"
              optionValue="value"
              appendTo="body" />
          </ng-template>
          <ng-template #help>
            Der kan vælges mellem følgende indbetalingstyper på
            depotsikringen:<br /><br />

            1: Indbetaling via indbetalingsaftale, gælder for aftaler betalt
            direkte fra arbejdsgiver - ej overløb<br />
            2: Indbetaling via konto, gælder for private aftaler<br />
            3: Indbetaling via pgf 41 overførsel, gælder for overløbsaftaler<br />
          </ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Skattekode">
          {{ letsikring.depotsikringSkattekode }}
          <ng-template #editor>
            <p-input-number
              formControlName="depotsikringSkattekode"
              locale="da"
              [maxFractionDigits]="0"
              [maxlength]="1"
              mode="decimal" />
          </ng-template>
        </app-detail-row>

        @if (
          letsikring.tegningsmaade === 'Arbejdsgiver' &&
          !letsikring.indbetalingHeltTilUdbetalingStart &&
          !letsikring.overloebFraRatepension
        ) {
          <app-detail-row
            [editMode]="editMode()"
            label="Sikring af saldo betales udover indbetalingsaftale" />

          <app-detail-row [editMode]="editMode()" label="Fra dato">
            {{ letsikring.depotsikringFraDato | date: 'dd-MM-yyyy' }}
          </app-detail-row>

          <app-detail-row [editMode]="editMode()" label="Frie midler"
            >{{ letsikring.frieMidler | boolean }}
            <ng-template #editor>
              <p-checkbox formControlName="frieMidler" [binary]="true" />
            </ng-template>
          </app-detail-row>

          <app-detail-row label="Betalingskonto" />
          <app-konto
            [editMode]="editMode()"
            [formPath]="[
              'gaeldendeRevision',
              'letsikringAfIndtaegt',
              'depotsikringBetalingsKonto',
            ]"
            [konto]="letsikring.depotsikringBetalingsKonto" />
        }
      }

      <div class="detail-section-header">Garanti</div>
      <app-detail-row [editMode]="editMode()" label="Garanti"
        >{{ letsikring.garanti | boolean }}
        <ng-template #editor>
          <p-checkbox formControlName="garanti" [binary]="true" />
        </ng-template>
      </app-detail-row>

      @if (
        letsikring.garanti ||
        form().value.gaeldendeRevision?.letsikringAfIndtaegt?.garanti
      ) {
        <app-detail-row [editMode]="editMode()" label="Antal år">
          {{ letsikring.garantiPeriode }}
          <ng-template #editor>
            <p-input-number
              formControlName="garantiPeriode"
              locale="da"
              [maxFractionDigits]="0"
              [maxlength]="3"
              mode="decimal" />
          </ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Maks garanti"
          >{{ letsikring.garantiMaks | boolean }}
          <ng-template #editor>
            <p-checkbox formControlName="garantiMaks" [binary]="true" />
          </ng-template>
        </app-detail-row>
      }

      <div class="detail-section-header">Medforsikret</div>
      <input hidden formControlName="medforsikredeId" />
      <app-detail-row [editMode]="editMode()" label="CPR-nummer">
        {{ letsikring.medforsikrede?.cprNummer }}
        <ng-template #editor>
          <app-kunde-selector
            [value]="letsikring.medforsikrede?.cprNummer"
            (kundeSelected)="onMedforsikredeSelected($event)" />
        </ng-template>
      </app-detail-row>
      <app-detail-row [editMode]="editMode()" label="Navn">
        {{ letsikring.medforsikrede?.navn }}
        <ng-template #editor>
          <div class="ml-3">
            {{
              form().value.gaeldendeRevision.letsikringAfIndtaegt
                ?.medforsikredeNavn
            }}
          </div>
        </ng-template>
      </app-detail-row>

      <div class="detail-section-header">Investering</div>

      <app-detail-row [editMode]="editMode()" label="Investeringsprofil"
        >{{ getInvesteringprofilText(letsikring.investeringsprofil) }}
        <ng-template #editor>
          <p-select
            [options]="investeringsprofilOptions"
            class="w-[178px]"
            formControlName="investeringsprofil"
            optionLabel="text"
            optionValue="value"
            appendTo="body" />
        </ng-template>
      </app-detail-row>

      @if (
        letsikring.investeringsprofil === 'V' ||
        form().value.gaeldendeRevision?.letsikringAfIndtaegt
          ?.investeringsprofil === 'V'
      ) {
        <app-detail-row
          [editMode]="editMode()"
          label="Investeringsandel (Højrisiko)">
          {{ letsikring.investeringsandelHoejRisiko }}
          <ng-template #editor>
            <p-input-number
              formControlName="investeringsandelHoejRisiko"
              locale="da"
              [maxFractionDigits]="0"
              [maxlength]="3"
              [max]="100"
              [min]="0"
              mode="decimal" />
          </ng-template>
        </app-detail-row>
      }

      <app-detail-row
        [editMode]="editMode()"
        label="Indfasning af udbetalingssikring"
        >{{ letsikring.udbetalingssikring | boolean }}
        <ng-template #editor>
          <p-checkbox formControlName="udbetalingssikring" [binary]="true" />
        </ng-template>
      </app-detail-row>

      <app-detail-row [editMode]="editMode()" label="KundeKapital"
        >{{ letsikring.kundeKapital | boolean }}
        <ng-template #editor>
          <p-checkbox formControlName="kundeKapital" [binary]="true" />
        </ng-template>
      </app-detail-row>

      <app-detail-row [editMode]="editMode()" label="Klima valgt"
        >{{ letsikring.klimaValgt | boolean }}
        <ng-template #editor>
          <p-checkbox formControlName="klimaValgt" [binary]="true" />
        </ng-template>
      </app-detail-row>

      @if (
        letsikring.klimaValgt ||
        form().value.gaeldendeRevision?.letsikringAfIndtaegt?.klimaValgt
      ) {
        <app-detail-row [editMode]="editMode()" label="Klima andel">
          {{ letsikring.investeringsandelKlimaplus }}
          <ng-template #editor>
            <p-input-number
              formControlName="investeringsandelKlimaplus"
              locale="da"
              [maxFractionDigits]="0"
              [maxlength]="3"
              [max]="100"
              [min]="0"
              mode="decimal" />
          </ng-template>
        </app-detail-row>
      }

      <div class="detail-section-header">Rabat på omkostninger</div>
      <app-detail-row
        [editMode]="editMode()"
        label="Rabat på vederlag af overført beløb (pct., decimaltal)">
        {{ letsikring.rabatVederlagOverfoerslerProcent | number: '1.1-9' }}
        <ng-template #editor>
          <p-input-number
            formControlName="rabatVederlagOverfoerslerProcent"
            maxFractionDigits="9"
            locale="da"
            mode="decimal" />
        </ng-template>
      </app-detail-row>

      <section formGroupName="indbetaling">
        <app-detail-row
          [editMode]="editMode()"
          label="Rabat på vederlag af løbende betalinger (pct., decimaltal)">
          {{
            letsikring.indbetaling?.rabatVederlagLoebendeIndbetalingerProcent
              | number: '1.1-9'
          }}
          <ng-template #editor>
            <p-input-number
              formControlName="rabatVederlagLoebendeIndbetalingerProcent"
              maxFractionDigits="9"
              locale="da"
              mode="decimal" />
          </ng-template>
        </app-detail-row>

        <app-detail-row
          [editMode]="editMode()"
          label="Rabat på vederlag af indskud (pct., decimaltal)">
          {{
            letsikring.indbetaling?.rabatVederlagEngangIndbetalingerProcent
              | number: '1.1-9'
          }}
          <ng-template #editor>
            <p-input-number
              formControlName="rabatVederlagEngangIndbetalingerProcent"
              maxFractionDigits="9"
              locale="da"
              mode="decimal" />
          </ng-template>
        </app-detail-row>
      </section>

      <app-detail-row [editMode]="editMode()" label="Rabat på vederlag af saldo"
        >{{ letsikring.saldoRabat | boolean }}
        <ng-template #editor>
          <p-checkbox formControlName="saldoRabat" [binary]="true" />
        </ng-template>
      </app-detail-row>
    </section>
  </section>
</div>
